angular.module('unergie.main')
.controller('consumptionPdlListCtrl', ($scope, TableGeneratorService, FilterMapping, BoFeaturesService, ApiUser, AlertManager, $timeout, ErrorCatcher) => {
    const canExportConsumptionCsv = BoFeaturesService.isFeatureOn('canExportConsumptionCsv')

    $scope.displayPage = true

    $scope.contract_status_mapping = FilterMapping.contractStatus
    $scope.contractsElec = {
        show: {},
        refreshing: false,
        columns: {
            'id': { label: 'Id', mode: 'search_wildcard', length: 9, mandatory: true },
            'account.brand': { label: 'Compte', mode: 'search_wildcard', mandatory: true },
            'account.organization': { label: 'Organisation', mode: 'search_wildcard' },
            'id_prm': { label: 'PRM', mode: 'search_wildcard', length: 14 },
            'prm.segment': { label: 'Segment', mode: 'hidden' },
            'label': { label: 'Libellé', mode: 'search_wildcard' },
            'category.name': { label: 'Paquet facturier', mode: 'search_wildcard' },
            'status': { label: 'Statut', mode: 'search_operator', binding: 'technical_status' },
            'technical_status': { label: 'Statut', mode: 'hidden', hidden_search: 'search_operator' },
            'max_power': { label: 'Puissance', mode: 'search_operator' },
            'power_unit': { label: 'Unité puissance', mode: 'hidden' },
            'addr_num_street': { label: 'Adresse', mode: 'search_wildcard' },
            'addr_post_code': { label: 'Code postal', mode: 'search_wildcard' },
            'addr_city_lbl': { label: 'Ville', mode: 'search_wildcard' },
            'actual_addr_num_street': { label: 'Adresse', mode: 'hidden' },
            'actual_addr_post_code': { label: 'Code postal', mode: 'hidden' },
            'actual_addr_city_lbl': { label: 'Ville', mode: 'hidden' },
            'metter_kind': { label: 'Type Compteur', mode: 'search_wildcard' },
            'service_level': { label: 'Niveau d\'ouverture aux service', mode: 'hidden' },
            'long_usage_context': { label: 'Contexte d\'utilisation', mode: 'hidden' },
            'long_usage_package': { label: 'Forfait (LU)', mode: 'hidden' },
            'commissioning_date': { label: 'Date activation', mode: 'search_date' },
            'decommissioning_date': { label: 'Date résiliation', mode: 'search_date' },
        },
    }

    let relateds = 'account,category,prm'
    const refresh = function () {
        if (Object.keys($scope.contractsElec.show).length > 0) {
            relateds = _.uniq(_.map(_.filter(Object.keys(_.pickBy($scope.contractsElec.show)), (s) => s.indexOf('.') > -1), (e) => e.split('.')[0])).join(',')
        }
        return TableGeneratorService.getTable($scope.contractsElec, 'pdls', relateds, null)
    }
    $scope.refresh = refresh
    refresh()

    $scope.isContractActive = (contract) => {
        return [2, 14, 4].includes(contract.technical_status)
    }

    $scope.isConsumptionDashboardAvailable = (contract) => {
        return $scope.isContractActive(contract) && (contract.prm.segment !== 'C5' || contract.service_level >= 2)
    }
    $scope.getConsumptionDashboardBtnTitle = (contract) => {
        if (!$scope.isContractActive(contract)) {
            return `Le contrat n'est pas actif.`
        }
        if (contract.prm.segment !== 'C5') {
            return
        }
        if (contract.service_level < 2) {
            return `Point de Livraison sans comptage ou pas encore équipé d'un compteur communiquant.`
        }
    }

    const exportDataLabel = {
        CDC: 'Courbes de charge',
        INDEXES: 'Index',
        PMAX: 'Puissance max atteinte',
        CONS: 'Consommation',
    }
    const exportData = {
        CDC: exportLoadCurve,
        INDEXES: exportIndexes,
        PMAX: exportPmax,
        CONS: exportConso,
    }
    const exportMaxDuration = {
        CDC: 1,
        INDEXES: 2,
        PMAXyear: 5,
        PMAXmonth: 2,
        PMAXweek: 2,
        PMAXday: 2,
        CONSyear: 5,
        CONSmonth: 2,
        CONSweek: 2,
        CONSday: 2,
    }
    const stepLabel = {
        year: 'ANNEE',
        month: 'MOIS',
        week: 'SEMAINE',
        day: 'JOUR',
    }
    const csvSeparator = ';'
    const csvHeader = {
        CDC: ['Début de période', 'Fin de période', 'Charge moyenne (kW)'].join(csvSeparator),
        INDEXES: ['Date', 'Calendrier', 'Classe temporelle', 'Index début de journée (Wh)'].join(csvSeparator),
        PMAX: ['Date', 'Classe temporelle', 'Puissance max (kVA)', 'Heure'].join(csvSeparator),
        CONS: ['Date', 'Calendrier', 'Classe temporelle', 'Consommation (kWh)'].join(csvSeparator),
    }

    $scope.exportRunning = {}
    $scope.exportFields = {
        dateFormatLabel: {
            type: 'label',
            label: `Le fuseau horaire utilisé est celui de Paris`,
        },
        dateFormatLabelBlank: { type: 'label', label: '&nbsp;' },
        dataType: {
            label: 'Type de données',
            type: 'radio',
            enum: [
                { label: 'Courbes de charge', value: 'CDC' },
                { label: `Index`, value: 'INDEXES' },
                { label: 'Puissance max atteinte', value: 'PMAX' },
                { label: 'Consommation', value: 'CONS' },
            ],
            onSelect: onDataTypeChange,
            required: true,
        },
        stepLabelBlank: {
            hidden: hiddenStepInput,
            type: 'label',
            label: '&nbsp;',
        },
        step: {
            hidden: hiddenStepInput,
            label: 'Granularité',
            type: 'radio',
            enum: [
                { label: 'Année', value: 'year' },
                { label: `Mois`, value: 'month' },
                { label: 'Semaine', value: 'week' },
                { label: 'Jour', value: 'day' },
            ],
            onSelect: onStepChange,
            required: true,
        },
        periodLabelBlank: {
            hidden: hiddenSubsetPicker,
            type: 'label',
            label: '&nbsp;',
        },
        periodLabel: {
            hidden: hiddenSubsetPicker,
            label: 'Période (dates incluses)',
        },
        startDate: {
            hidden: hiddenSubsetPicker,
            label: 'Date de début',
            type: 'date',
            required: true,
            max: () => moment().format('YYYY-MM-DD')
        },
        endDate: {
            hidden: hiddenSubsetPicker,
            label: 'Date de fin',
            type: 'date',
            min: endDateMin,
            max: endDateMax,
            required: true,
        },
        periodLimitLabel: {
            hidden: hiddenSubsetPicker,
            type: 'label',
            label: (f) => {
                const maxDuration = getMaxDuration(f)
                return `La période demandée doit être inférieure ou égale à ${maxDuration} an${(maxDuration > 1) ? 's' : ''}`
            },
        },
        indexesInformation: {
            hidden: (f) => f.dataType !== 'INDEXES',
            type: 'label',
            label: 'Les index renseignés sont ceux en début de journée',
        },
    }
    $scope.exportTemplate = {}

    $scope.isExportAvailable = (contract) => {
        return canExportConsumptionCsv && $scope.isContractActive(contract) && (contract.prm.segment !== 'C5' || contract.service_level >= 2)
    }

    $scope.export = (contract) => {
        const dataType = $scope.exportTemplate.dataType
        const step = ['PMAX', 'CONS'].includes($scope.exportTemplate.dataType) ? `${stepLabel[$scope.exportTemplate.step]}_` : ''

        const mStartDate = moment($scope.exportTemplate.startDate)
        const startDate = mStartDate.format('YYYY-MM-DD')
        const mEndDate = moment($scope.exportTemplate.endDate).add(1, 'day')
        const endDate = mEndDate.format('YYYY-MM-DD')
        const period = {
            mStartDate,
            startDate,
            mEndDate,
            endDate,
        }

        if (mStartDate > mEndDate) {
            return AlertManager.error(`La date de début doit être antérieure ou égale à la date de fin`)
        }
        const maxDuration = getMaxDuration()
        if (mStartDate.add(maxDuration, 'year') < mEndDate) {
            return AlertManager.error(`La période demandée doit être inférieure ou égale à ${maxDuration} an${(maxDuration > 1) ? 's' : ''}`)
        }

        $scope.exportRunning[contract.id] = true
        exportData[dataType](contract, period)
        .then((data) => {
            if (data) {
                const blob = new Blob(['\uFEFF', data], { type: 'text/csv' })
                const url = URL.createObjectURL(blob)
                const a = document.createElement('a')
                a.href = url
                a.download = `${contract.id_prm}_${dataType}_${step}${moment().format('YYYYMMDD')}.csv`
                a.target = '_blank'
                document.body.appendChild(a)
                $timeout(() => {
                    a.click()
                })
                return AlertManager.success(`Génération du CSV`)
            }
            return AlertManager.error(`Nous n’avons aucune donnée de type '${exportDataLabel[dataType]}' sur la période sélectionnée`)
        })
        .catch(ErrorCatcher)
        .finally(() => {
            $scope.exportRunning[contract.id] = false
        })
    }

    $scope.resetExport = () => {
        $scope.exportTemplate.dataType = null
        $scope.exportTemplate.step = null
        $scope.exportTemplate.startDate = null
        $scope.exportTemplate.endDate = null
    }

    function onDataTypeChange() {
        $scope.exportTemplate.step = null
        $scope.exportTemplate.startDate = null
        $scope.exportTemplate.endDate = null
    }

    function onStepChange() {
        $scope.exportTemplate.startDate = null
        $scope.exportTemplate.endDate = null
    }

    $scope.$watch('exportTemplate.startDate', () => {
        if (!$scope.exportTemplate.endDate) {
            return
        }
        if (!$scope.exportTemplate.startDate) {
            return
        }
        const t = $scope.exportTemplate
        let mEndDate = moment(t.endDate)
        const mMinDate = moment(endDateMin(t))
        const mMaxDate = moment(endDateMax(t))
        if (mEndDate < mMinDate) {
            mEndDate = mMinDate
        }
        if (mEndDate > mMaxDate) {
            mEndDate = mMaxDate
        }
        $scope.exportTemplate.endDate = mEndDate.format('YYYY-MM-DD')
    })

    function hiddenStepInput(template) {
        return !['PMAX', 'CONS'].includes(template.dataType)
    }

    function hiddenSubsetPicker(template) {
        return !template.dataType || (['PMAX', 'CONS'].includes(template.dataType) && !template.step)
    }

    function endDateMin(template) {
        return template.startDate
    }
    function endDateMax(template) {
        if (template.startDate) {
            const maxDuration = getMaxDuration(template)
            return moment.min(moment(template.startDate).add(maxDuration, 'year').subtract(1, 'day'), moment()).format('YYYY-MM-DD')
        }
        return moment().format('YYYY-MM-DD')
    }
    function getMaxDuration(template = null) {
        const t = template || $scope.exportTemplate
        return exportMaxDuration[`${t.dataType}${t.step ? t.step : ''}`]
    }

    function exportLoadCurve(contract, { mStartDate, startDate, mEndDate, endDate }) {
        return ApiUser.getLoadCurves({
            idContract: contract.id,
            subset: `${startDate},${endDate}`,
            unit: 'kW',
            export: true,
        })
        .$promise.then((pointList) => {
            if (pointList.length) {
                const list = pointList.map((point) => {
                    return [
                        point.timePeriod.startDate,
                        point.timePeriod.endDate,
                        getUnavailableLabel(point?.loadCurve?.value),
                    ].join(csvSeparator)
                }).join('\n')
                return `${csvHeader.CDC}\n${list}`
            }
            return null
        })
    }

    function exportIndexes(contract, { mStartDate, startDate, mEndDate, endDate }) {
        return ApiUser.getIndexes({
            idContract: contract.id,
            subset: `${startDate},${endDate}`,
            unit: 'Wh',
            export: true,
        })
        .$promise.then((indexList) => {
            if (indexList.length) {
                const list = [csvHeader.INDEXES]
                indexList.forEach((index) => {
                    const date = index.date
                    const calendar = index?.grid?.provider?.calendar?.id || ''
                    const tempClassList = Object.entries(index?.grid?.provider?.tempClass || {})
                    tempClassList.forEach((tempClass) => {
                        list.push([
                            date,
                            calendar,
                            tempClass[0],
                            getUnavailableLabel(tempClass[1]?.value),
                        ].join(csvSeparator))
                    })
                    if (!tempClassList.length) {
                        list.push([
                            date,
                            calendar,
                            '',
                            getUnavailableLabel(),
                        ].join(csvSeparator))
                    }
                })
                return list.join('\n')
            }
            return null
        })
    }

    function exportPmax(contract, { mStartDate, startDate, mEndDate, endDate }) {
        const step = $scope.exportTemplate.step

        return ApiUser.getPowerMaxHistory({
            idContract: contract.id,
            subset: `${startDate},${endDate}`,
            step,
            unit: 'kVA',
            export: true,
        })
        .$promise.then((pmaxList) => {
            if (pmaxList.length) {
                const list = pmaxList.map((pmax) => {
                    if (pmax.tempClass) {
                        return Object.entries(pmax.tempClass).map(([tempClass, power]) => {
                            return [
                                pmax.date,
                                tempClass,
                                getUnavailableLabel(power.value),
                                getUnavailableLabel(power.peakDate),
                            ].join(csvSeparator)
                        }).join('\n')
                    }
                    return [
                        pmax.date,
                        getUnavailableLabel(pmax.tempClass),
                        getUnavailableLabel(pmax.value),
                        getUnavailableLabel(pmax.peakDate),
                    ].join(csvSeparator)
                }).join('\n')
                return `${csvHeader.PMAX}\n${list}`
            }
            return null
        })
    }

    function exportConso(contract, { mStartDate, startDate, mEndDate, endDate }) {
        const step = $scope.exportTemplate.step

        return ApiUser.getConso({
            idContract: contract.id,
            subset: `${startDate},${endDate}`,
            step,
            unit: 'kWh',
            export: true,
        })
        .$promise.then((consList) => {
            if (consList.length) {
                const list = [csvHeader.CONS]
                consList.forEach((cons) => {
                    const date = cons.timePeriod.startDate
                    const calendar = cons.calendar
                    const tempClassList = Object.entries(cons.tempClass || {})
                    tempClassList.forEach(([tempClass, consumption]) => {
                        list.push([
                            date,
                            calendar,
                            tempClass,
                            getUnavailableLabel(consumption?.value),
                        ].join(csvSeparator))
                    })
                    if (tempClassList.length > 1) {
                        list.push([
                            date,
                            calendar,
                            'Total',
                            cons.total.value,
                        ].join(csvSeparator))
                    }
                    if (!tempClassList.length) {
                        list.push([
                            date,
                            calendar,
                            '',
                            getUnavailableLabel(),
                        ].join(csvSeparator))
                    }
                })
                return list.join('\n')
            }
            return null
        })
    }

    function getUnavailableLabel(value) {
        return _.isNil(value) ? 'indisponible' : value
    }
})
